export default __webpack_public_path__ + "static/media/hero-pump-testing.75faf7a7.webp";